export function buildPlanarActorEntry(data, source) {
    const referenceFields = getActorEntryReferenceFields(data.reference, data.volumeId || source.referencedIdFallback);
    const actor = source.actor;
    const mapper = source.mapper ??
        (typeof actor.getMapper === 'function'
            ? actor.getMapper()
            : undefined);
    return {
        uid: source.uid,
        actor: actor,
        actorMapper: {
            actor,
            mapper,
            renderMode: source.renderMode,
        },
        ...referenceFields,
    };
}
function getActorEntryReferenceFields(reference, fallbackReferencedId) {
    if (!reference) {
        return fallbackReferencedId ? { referencedId: fallbackReferencedId } : {};
    }
    if (reference.kind === 'segmentation') {
        return {
            reference,
            referencedId: reference.labelmapId ??
                reference.representationUID ??
                reference.segmentationId,
            ...(reference.representationUID
                ? { representationUID: reference.representationUID }
                : {}),
        };
    }
    return {
        reference,
        referencedId: getReferenceId(reference),
    };
}
function getReferenceId(reference) {
    switch (reference.kind) {
        case 'data':
            return reference.dataId;
        case 'image':
            return reference.imageId;
        case 'volume':
            return reference.volumeId;
        case 'geometry':
            return reference.geometryId;
        case 'segmentation':
            return (reference.labelmapId ??
                reference.representationUID ??
                reference.segmentationId);
    }
}
